import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=74188057"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74188057')) {
      api.createRecord('74188057', component.options)
    } else {
      api.reload('74188057', component.options)
    }
    module.hot.accept("./EventCategory.vue?vue&type=template&id=74188057", function () {
      api.rerender('74188057', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/EventCategory.vue"
export default component.exports